export default __webpack_public_path__ + "components/weather-icon/static/daymodrain@3-be38c2f2cca9807124d409938a91a75a.png";